<template>
  <div class="registration-page">
    <div class="registration-page-container">
      <div class="section">
        <div class="section-header">
          <h3>구매자정보</h3>
        </div>
        <div class="section-body">
          <dl class="field-group">
            <dt class="field-label">
              구매대리점
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ openMarketInfo.agentName }}({{ openMarketInfo.dealCd }})
                </p>
              </div>
            </dd>
          </dl>
          <dl class="field-group">
            <dt class="field-label">
              구매쇼핑몰
            </dt>
            <dd class="field-control">
              <div class="field-control-sub">
                <p class="data-text">
                  {{ openMarketInfo.openMarketName }}
                </p>
              </div>
            </dd>
          </dl>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'BasicInformationSectionView',
  props: {
    openMarketInfoProps: Object
  },

  data() {
    return {
      openMarketInfo: ''
    }
  },

  computed: {},

  mounted() {
    this.openMarketInfo = this.openMarketInfoProps
  },

  methods: {}
}
</script>

<style scoped></style>
